import React from 'react';
import { MapPin, Phone, Clock } from 'lucide-react';

export default function Contact() {
  return (
    <main className="pt-32 pb-24">
      <div className="max-w-7xl mx-auto px-6">
        <div className="mb-16">
          <div className="flex items-center gap-4 mb-6">
            <div className="h-[1px] w-12 bg-[#4b717a]" />
            <span className="text-[#4b717a] text-xs tracking-[0.4em] uppercase font-bold">Kontakt os</span>
          </div>
          <h1 className="text-5xl md:text-6xl font-sans font-medium text-black mb-6 leading-tight tracking-tight">
            Vi er her for <br />dig
          </h1>
          <p className="text-slate-500 max-w-xl text-base leading-relaxed">
            Du er altid velkommen til at kontakte os i telefontiden eller besøge vores klinik i Hellerup. Herunder finder du alle praktiske informationer.
          </p>
        </div>

        {/* Contact Info Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16">
          {/* Adresse */}
          <div className="bg-white p-8 border border-slate-100 shadow-sm rounded-2xl flex flex-col gap-4 transition-all hover:shadow-md">
            <div className="w-12 h-12 rounded-full bg-[#4b717a]/10 flex items-center justify-center text-[#4b717a]">
              <MapPin size={24} />
            </div>
            <div>
              <h3 className="font-sans font-semibold text-xl text-black mb-2">Adresse</h3>
              <p className="text-slate-500 text-sm leading-relaxed">
                Bernstorffsvej 20 C, 2. sal<br />
                2900 Hellerup
              </p>
            </div>
          </div>

          {/* Telefon */}
          <div className="bg-white p-8 border border-slate-100 shadow-sm rounded-2xl flex flex-col gap-4 transition-all hover:shadow-md">
            <div className="w-12 h-12 rounded-full bg-[#4b717a]/10 flex items-center justify-center text-[#4b717a]">
              <Phone size={24} />
            </div>
            <div>
              <h3 className="font-sans font-semibold text-xl text-black mb-2">Telefon</h3>
              <p className="text-slate-500 text-sm leading-relaxed">
                <span className="text-lg font-medium text-black block mb-1">70 60 22 02</span>
                <span className="text-xs text-slate-400 block">Telefontid: 8:00 - 12:00</span>
                <span className="text-xs text-slate-400 block">(lukket 10:00 - 10:15)</span>
              </p>
            </div>
          </div>

          {/* Åbningstider */}
          <div className="bg-white p-8 border border-slate-100 shadow-sm rounded-2xl flex flex-col gap-4 transition-all hover:shadow-md">
            <div className="w-12 h-12 rounded-full bg-[#4b717a]/10 flex items-center justify-center text-[#4b717a]">
              <Clock size={24} />
            </div>
            <div>
              <h3 className="font-sans font-semibold text-xl text-black mb-2">Åbningstider</h3>
              <div className="text-slate-500 text-sm leading-relaxed flex flex-col gap-1">
                <div className="flex justify-between">
                  <span>Man-Tirs, Tors-Fre:</span>
                  <span className="font-medium text-slate-700">8:00 - 16:00</span>
                </div>
                <div className="flex justify-between">
                  <span>Onsdag:</span>
                  <span className="font-medium text-slate-700">8:00 - 17:30</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Map Section */}
        <div className="bg-white border border-slate-100 shadow-sm rounded-3xl overflow-hidden h-[450px] relative">
          <iframe
            title="Kort over Bernstorffsvej 20 C"
            src="https://maps.google.com/maps?q=Bernstorffsvej%2020C,%202900%20Hellerup&t=&z=15&ie=UTF8&iwloc=&output=embed"
            width="100%"
            height="100%"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            className="absolute inset-0"
          ></iframe>
        </div>
      </div>
    </main>
  );
}
